"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeZone = exports.SettlementType = exports.DoubleBinaryType = exports.BinaryType = exports.BarrierMode = exports.InOrOut = exports.UpOrDown = exports.UnderlyingType = exports.PricingModelType = exports.DividendType = exports.VolatilityType = exports.TimeStamp = exports.VolatilityModel = exports.Outputs = exports.PriceSide = exports.FxSwapCalculationMethod = exports.ExerciseStyle = exports.CallPut = exports.BuySell = void 0;
var financial_contracts_1 = require("./financial-contracts");
Object.defineProperty(exports, "BuySell", { enumerable: true, get: function () { return financial_contracts_1.BuySell; } });
Object.defineProperty(exports, "CallPut", { enumerable: true, get: function () { return financial_contracts_1.CallPut; } });
Object.defineProperty(exports, "ExerciseStyle", { enumerable: true, get: function () { return financial_contracts_1.ExerciseStyle; } });
Object.defineProperty(exports, "FxSwapCalculationMethod", { enumerable: true, get: function () { return financial_contracts_1.FxSwapCalculationMethod; } });
Object.defineProperty(exports, "PriceSide", { enumerable: true, get: function () { return financial_contracts_1.PriceSide; } });
Object.defineProperty(exports, "Outputs", { enumerable: true, get: function () { return financial_contracts_1.Outputs; } });
var VolatilityModel;
(function (VolatilityModel) {
    VolatilityModel["SABR"] = "SABR";
    VolatilityModel["CubicSpline"] = "CubicSpline";
    VolatilityModel["SVI"] = "SVI";
    VolatilityModel["TwinLognormal"] = "TwinLognormal";
    VolatilityModel["VannaVolga"] = "VannaVolga";
})(VolatilityModel || (exports.VolatilityModel = VolatilityModel = {}));
var TimeStamp;
(function (TimeStamp) {
    TimeStamp["Open"] = "Open";
    TimeStamp["Close"] = "Close";
    TimeStamp["Default"] = "Default";
})(TimeStamp || (exports.TimeStamp = TimeStamp = {}));
var VolatilityType;
(function (VolatilityType) {
    VolatilityType["Implied"] = "Implied";
    VolatilityType["SVISurface"] = "SVISurface";
})(VolatilityType || (exports.VolatilityType = VolatilityType = {}));
var DividendType;
(function (DividendType) {
    DividendType["None"] = "None";
    DividendType["ForecastTable"] = "ForecastTable";
    DividendType["HistoricalYield"] = "HistoricalYield";
    DividendType["ForecastYield"] = "ForecastYield";
    DividendType["ImpliedYield"] = "ImpliedYield";
    DividendType["ImpliedTable"] = "ImpliedTable";
})(DividendType || (exports.DividendType = DividendType = {}));
var PricingModelType;
(function (PricingModelType) {
    PricingModelType["BlackScholes"] = "BlackScholes";
    PricingModelType["Whaley"] = "Whaley";
    PricingModelType["Binomial"] = "Binomial";
    PricingModelType["Trinomial"] = "Trinomial";
    PricingModelType["VannaVolga"] = "VannaVolga";
})(PricingModelType || (exports.PricingModelType = PricingModelType = {}));
var UnderlyingType;
(function (UnderlyingType) {
    UnderlyingType["Eti"] = "Eti";
    UnderlyingType["Fx"] = "Fx";
})(UnderlyingType || (exports.UnderlyingType = UnderlyingType = {}));
var UpOrDown;
(function (UpOrDown) {
    UpOrDown["Up"] = "Up";
    UpOrDown["Down"] = "Down";
})(UpOrDown || (exports.UpOrDown = UpOrDown = {}));
var InOrOut;
(function (InOrOut) {
    InOrOut["In"] = "In";
    InOrOut["Out"] = "Out";
})(InOrOut || (exports.InOrOut = InOrOut = {}));
var BarrierMode;
(function (BarrierMode) {
    BarrierMode["European"] = "European";
    BarrierMode["American"] = "American";
    BarrierMode["ForwardStartWindow"] = "ForwardStartWindow";
    BarrierMode["EarlyEndWindow"] = "EarlyEndWindow";
})(BarrierMode || (exports.BarrierMode = BarrierMode = {}));
var BinaryType;
(function (BinaryType) {
    BinaryType["OneTouch"] = "OneTouch";
    BinaryType["NoTouch"] = "NoTouch";
    BinaryType["Digital"] = "Digital";
    BinaryType["OneTouchImmediate"] = "OneTouchImmediate";
    BinaryType["OneTouchDeferred"] = "OneTouchDeferred";
})(BinaryType || (exports.BinaryType = BinaryType = {}));
var DoubleBinaryType;
(function (DoubleBinaryType) {
    DoubleBinaryType["DoubleNoTouch"] = "DoubleNoTouch";
})(DoubleBinaryType || (exports.DoubleBinaryType = DoubleBinaryType = {}));
var SettlementType;
(function (SettlementType) {
    SettlementType["Cash"] = "Cash";
    SettlementType["Asset"] = "Asset";
})(SettlementType || (exports.SettlementType = SettlementType = {}));
var TimeZone;
(function (TimeZone) {
    TimeZone["BJS"] = "BJS";
    TimeZone["BKK"] = "BKK";
    TimeZone["BOM"] = "BOM";
    TimeZone["BUD"] = "BUD";
    TimeZone["FFT"] = "FFT";
    TimeZone["HKG"] = "HKG";
    TimeZone["KUL"] = "KUL";
    TimeZone["LON"] = "LON";
    TimeZone["MNL"] = "MNL";
    TimeZone["NYC"] = "NYC";
    TimeZone["SAO"] = "SAO";
    TimeZone["SEL"] = "SEL";
    TimeZone["SIN"] = "SIN";
    TimeZone["TPE"] = "TPE";
    TimeZone["TOK"] = "TOK";
    TimeZone["WAW"] = "WAW";
    TimeZone["GMT"] = "GMT";
})(TimeZone || (exports.TimeZone = TimeZone = {}));
